module.exports = __webpack_public_path__ + "static/img/bc1-8.9f1e4e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bc1-8.png
// module id = 829
// module chunks = 0